<template>
  <div class="cloudDesktop">
    <div class="baner">
      <img :src="bgsrc" alt>
    </div>
    <div class="introduction">
      <ul>
        <li v-for="(item ,index) in inters" :key="index">
          <img :src="item.src" alt>
          <h2 class="int_title">{{item.title}}</h2>
          <div class="int_content">
            <p>{{item.content}}</p>
          </div>
        </li>
      </ul>
    </div>
    <div class="composition">
      <div class="com_title">{{composition.title}}</div>
      <div class="com_brief">{{composition.brief}}</div>
      <div class="com_box">
        <ul>
          <li v-for="(item,index) in composition.box" :key="index">
            <img :src="item.src" alt>
            <p>{{item.content}}</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="application">
      <div class="app_title">{{application.title}}</div>
      <div class="app_box1">
        <ul>
          <li v-for="(value,indexs) in application.box1" :key="indexs">
            <img class="app_box_img" :src="value.src">
            <div class="app_box_title">{{value.title}}</div>
            <div class="app_box_content" v-for="(item,index) in value.content" :key="index">{{item}}</div>
          </li>
        </ul>
      </div>
      <div class="app_box2">
        <ul>
          <li v-for="(value,indexs) in application.box2" :key="indexs">
            <img class="app_box_img" :src="value.src">
            <div class="app_box_title">{{value.title}}</div>
            <div class="app_box_content" v-for="(item,index) in value.content" :key="index">{{item}}</div>
          </li>
        </ul>
      </div>
    </div>
    <div class="program">
      <div class="pro_title">{{program.title}}</div>
      <div class="pro_box1">
        <ul>
          <li v-for="(value,index) in program.box1" :key="index">
            <div class="pro_box_title">{{value.title}}</div>
            <div
              class="pro_box_content"
              v-for="(item,indexs) in value.content"
              :key="indexs"
            >{{item}}</div>
          </li>
        </ul>

        <div></div>
      </div>
      <div class="pro_box2">
        <ul>
          <li v-for="(value,index) in program.box2" :key="index">
            <div class="pro_box_title">{{value.title}}</div>
            <div
              class="pro_box_content"
              v-for="(item,indexs) in value.content"
              :key="indexs"
            >{{item}}</div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bgsrc: "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/desktop/deskop_02.png",
      inters: [
        {
          title: "云平台",
          content:
            "支持 NViDIA、AMD、intel 多种虚拟化方案，并提供计算、储存、网络等资源池管理",
          src: "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/desktop/deskop_05.png"
        },
        {
          title: "低延时传输管道",
          content:
            "通过对网络自适应和低超时操作的深度优化，让云平台能够提供更高的桌面操作体验，并极大减轻网络的带宽压力",
          src: "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/desktop/deskop_11.png"
        },
        {
          title: "多终端支持",
          content: "支持不同系统与不同的芯片厂商的终端，支持硬件解码协议",
          src: "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/desktop/deskop_13.png"
        },
        {
          title: "行业定制",
          content: "可根据不同的行业进行云平台深度定制化",
          src: "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/desktop/deskop_08.png"
        }
      ],
      composition: {
        title: "产品组成",
        brief:
          "云教室包含三款产品：虚拟云桌面服务器、云终端、Bridgetek云桌面虚拟化平台。",
        box: [
          {
            src: "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/desktop/deskop_20.png",
            content: "云终端"
          },
          {
            src: "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/desktop/deskop_22.png",
            content: "BridgeTeke云桌面虚拟化平台"
          },
          {
            src: "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/desktop/deskop_24.png",
            content: "虚拟云桌面服务器"
          }
        ]
      },
      application: {
        title: "应用场景",
        box1: [
          {
            src: "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/desktop/deskop_36.png",
            title: "校园云",
            content: [
              "将计算，储存以及数据资源作为服务，通过网络提供给教师和学生，鼓励校内的各种形式的创新"
            ]
          },
          {
            src: "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/desktop/deskop_30.png",
            title: "远程教学/远程实验室",
            content: ["便捷访问托管桌面", "远程访问机房环境"]
          },
          {
            src: "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/desktop/deskop_33.png",
            title: "图书馆/阅览室",
            content: ["自动查询终端", "锁定的工作环境", "定时系统重置"]
          }
        ],
        box2: [
          {
            src: "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/desktop/deskop_41.png",
            title: "学校实验室/机房",
            content: ["快速更新系统环境", "高安全/易管理", "用户数据永久保存"]
          },
          {
            src: "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/desktop/deskop_43.png",
            title: "绿色校园",
            content: ["节能减排", "绿色IT"]
          },
          {
            src: "http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/desktop/deskop_45.png",
            title: "教师在不同教师间漫游",
            content: ["远程备课", "在不同多媒体教室间漫游", "永久工作环境"]
          }
        ]
      },
      program: {
        title: "方案特点",
        box1: [
          {
            title: "极致桌面体验",
            content: [
              "与 PC 一致的桌面体验",
              "桌面安全连接，传输加密",
              "操作稳定，3000亿次压力测试无卡顿",
              "1080高清页面操作流畅，低带宽占用"
            ],
            class: "exp"
          },
          {
            title: "部署快速",
            content: [
              "模板派送，3分钟快速生产上百桌面",
              "新员工入职，桌面资源随需分发"
            ],
            class: "deploy"
          }
        ],
        box2: [
          {
            title: "管理简单",
            content: [
              "一个 web 管理控制台",
              "业务软件或者系统软件升级时，一键更新，无需逐台处理",
              "按需调节CPU核数、内存大小或者磁盘空间"
            ],
            class: "admin"
          },
          {
            title: "外设全兼容",
            content: [
              "摄像头、快拍仪",
              "支持端口和设备映射",
              "快速定制特殊化外设接口"
            ],
            class: "device"
          }
        ]
      }
    };
  }
};
</script>

<style scoped>
* {
  line-height: 24px;
}
.baner {
  height: 450px;
  width: 100%;
}
.baner img {
  width: 100%;
}
.introduction {
  height: 460px;
  width: 100%;
  /* display: -webkit-flex;*/
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  /* padding-top: 80px; */
}
.introduction li {
  height: 300px;
  width: 244px;
  display: inline-block;
  text-align: center;
  vertical-align: text-top;
}
.introduction li + li {
  margin-left: 88px;
}
.introduction li img {
  height: 120px;
  width: 120px;
  display: block;
  margin-left: auto;
  margin-right: auto;
}
.introduction li .int_title {
  font-size: 24px;
  color: #505050;
  padding-top: 20px;
  /* padding-bottom: 20px; */
}
.introduction li .int_content {
  padding-top: 20px;
  max-width: 208px;
  display: inline-block;
  text-indent: 10px;
  font-size: 12px;
  color: #949494;
}
.composition {
  /* height: 416px; */
  width: 100%;
  text-align: center;
  background-color: #f7f7f7;
}
.composition .com_title {
  font-size: 36px;
  color: #505050;
  padding-top: 100px;
}
.composition .com_brief {
  font-size: 16px;
  color: #949494;
  padding-top: 40px;
}
.composition .com_box {
  margin-top: 100px;
  padding-bottom: 100px;
}
.composition .com_box li {
  display: inline-block;
  /* border: 1px solid; */
  width: 324px;
  /* height: 224px;; */
}
.composition .com_box li + li {
  margin-left: 84px;
}

.composition .com_box li img {
  height: 164px;
  width: 300px;
  display: block;
  margin: 0 auto;
}
.composition .com_box li p {
  display: inline-block;
  height: 40px;
  line-height: 40px;
  margin-top: 20px;
  width: 324px;
  background-color: #fbdaa8;
  border-radius: 20px;
  margin-left: auto;
  margin-right: auto;
}
.composition .com_box li p + p {
  margin-left: 84px;
}

.application {
  text-align: center;
}
.application .app_box2 {
  margin-bottom: 100px;
}
.application .app_title {
  font-size: 36px;
  color: #505050;
  margin-top: 100px;
  margin-bottom: 94px;
}
.application ul {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 94px;
}
.application ul li {
  /* flex: 0 0 33%; */
  height: 366px;
  width: 350px;
  text-align: center;
  box-shadow:0px 0px 20px #dddddd;
  /* margin-left: 74px; */
}
.application ul li + li {
  margin-left: 74px;
}
.application .app_box_img {
  height: 130px;
  width: 130px;
  display: block;
  margin-top: 30px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 25px;
}
.application .app_box_title {
  font-size: 18px;
  color: #505050;
  margin-bottom: 28px;
}
.application .app_box_content {
  padding: 0 35px;
  font-size: 14px;
  color: #949494;
}

.program {
  text-align: center;
  background-color: #f7f7f7;
  padding-bottom: 150px;
  padding-top: 100px;
}
.program .pro_title {
  font-size: 36px;
  color: #505050;

  margin-bottom: 94px;
}
.program ul {
  display: flex;
  justify-content: center;
}
.program li {
  align-items: flex-start;
  display: inline-block;
  height: 200px;
  width: 580px;
  text-align: left;
  padding-left: 30px;
 
}

.program .pro_box2 {
  margin-top: 20px;
}
.program li .pro_box_title {
  font-size: 24px;
  color: #505050;
  margin-top: 30px;
  margin-bottom: 20px;
}
.program li .pro_box_content {
  font-size: 12px;
  color: #949494;
}
/* .program  li .pro_box_content+.pro_box_content {
  margin-top: 24px;
} */
.program li + li {
  margin-left: 40px;
}
.program .pro_box1 li:nth-of-type(1) {
  background: url(http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/desktop/deskop_50.png) repeat;
}
.program .pro_box1 li:nth-of-type(2) {
  background: url(http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/desktop/deskop_52.png) repeat;
}
.program .pro_box2 li:nth-of-type(1) {
  background: url(http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/desktop/deskop_56.png) repeat;
}
.program .pro_box2 li:nth-of-type(2) {
  background: url(http://byyb-thumbnail.oss-cn-hangzhou.aliyuncs.com/resource/bridgetek-web/images/desktop/deskop_57.png) repeat;
}
</style>


// WEBPACK FOOTER //
// src/components/cloudDesktop.vue